export default "__VITE_ASSET__BpIv4WVi__"